import { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import {
  getCantidadTalentosGlobalService,
  putCantidadTalentosGlobalService,
} from "../../services/cantidadTalentos/cantidadTalentos.service.js";

const parsePositiveInt = (value, fallback = 0) => {
  const n = parseInt(value, 10);
  if (Number.isNaN(n) || n < 0) return fallback;
  return n;
};

const ConfiguracionTalentosGlobal = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [positivos, setPositivos] = useState(5);
  const [negativos, setNegativos] = useState(5);

  const fetchGlobal = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getCantidadTalentosGlobalService();
      setPositivos(
        typeof data.cantidad_talentos_positivos === "number"
          ? data.cantidad_talentos_positivos
          : 5
      );
      setNegativos(
        typeof data.cantidad_talentos_negativos === "number"
          ? data.cantidad_talentos_negativos
          : 5
      );
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.detail ||
        "Error al cargar la configuración global";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGlobal();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess(null);
    setError(null);

    const p = parsePositiveInt(positivos, 0);
    const n = parsePositiveInt(negativos, 0);

    if (p < 0 || n < 0) {
      setError("Solo se permiten valores enteros positivos.");
      return;
    }

    setSaving(true);
    try {
      await putCantidadTalentosGlobalService({
        cantidad_talentos_positivos: p,
        cantidad_talentos_negativos: n,
      });
      setPositivos(p);
      setNegativos(n);
      setSuccess("Configuración global guardada correctamente.");
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.detail ||
        "Error al guardar la configuración global";
      setError(msg);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="py-4">
        <Loader center text="Cargando configuración global..." delay={200} />
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      {error && (
        <Alert message={error} variant="error" onClose={() => setError(null)} />
      )}
      {success && (
        <Alert
          message={success}
          variant="success"
          onClose={() => setSuccess(null)}
        />
      )}

      <div className="row g-3">
        <div className="col-12">
          <label className="form-label fw-medium d-flex align-items-center gap-1">
            <Icon icon="mdi:thumb-up-outline" width={16} className="text-success" />
            Talentos más destacados
          </label>
          <input
            type="number"
            min="0"
            step="1"
            className="form-control bg-base border text-center fw-semibold"
            value={positivos}
            onChange={(e) => setPositivos(parsePositiveInt(e.target.value, 0))}
            disabled={saving}
          />
        </div>
        <div className="col-12">
          <label className="form-label fw-medium d-flex align-items-center gap-1">
            <Icon icon="mdi:thumb-down-outline" width={16} className="text-danger" />
            Talentos menos destacados
          </label>
          <input
            type="number"
            min="0"
            step="1"
            className="form-control bg-base border text-center fw-semibold"
            value={negativos}
            onChange={(e) => setNegativos(parsePositiveInt(e.target.value, 0))}
            disabled={saving}
          />
        </div>
      </div>

      <div className="mt-4 d-grid">
        <button
          type="submit"
          className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
          disabled={saving}
        >
          {saving ? (
            <>
              <Loader type="spinner" size="sm" delay={0} />
              Guardando...
            </>
          ) : (
            <>
              <Icon icon="mdi:content-save" width="20" height="20" />
              Guardar configuración
            </>
          )}
        </button>
      </div>
    </form>
  );
};

export default ConfiguracionTalentosGlobal;
